export default {
  socket: (process.env.NODE_ENV == "development") ?  '//ee63cefbb62a4888a0a1649f162a69c9.vfs.cloud9.us-east-1.amazonaws.com:8081': null,
  software: {name: 'ERP', type: 'Software', icon: 'cloud-database'},
  page: {
      footer :  "Copyright &copy; 2019 Nederlandskenniscentrum"
  },
  help: {
      intro_question_laed_empty: "Gebruik onderstaande vragenlijst als leidraad tijdens uw gesprekken met leveranciers of selecteer van te voren welke vragen u wilt stellen en hou de tijdslijn in de gaten.<br><br>Stel leveranciers specifieke vragenlijsten samen via de knop Leveranciers.<br><br>U kunt de vragenlijst(en) printen via het printer icon maar als u naar de kennisdag komt van het NederlandsKennisCentrum, hoeft u verder niks te doen. In dat geval wordt de vragenlijst automatisch opgenomen in uw persoonlijk programma die u op de dag zelf uitgereikt krijgt.",
      intro_question_laed: "Gebruik onderstaande vragenlijst als leidraad tijdens uw gesprekken met leveranciers of selecteer van te voren welke vragen u wilt stellen en hou de tijdslijn in de gaten.<br><br>Stel leveranciers specifieke vragenlijsten samen via de knop Leveranciers.<br><br>U kunt de vragenlijst(en) printen via het printer icon maar als u naar de kennisdag komt van het NederlandsKennisCentrum, hoeft u verder niks te doen. In dat geval wordt de vragenlijst automatisch opgenomen in uw persoonlijk programma die u op de dag zelf uitgereikt krijgt.",
      intro_question_laed_supplier: "Stel de vragenlijst specifiek samen voor een leverancier door vragen toe te voegen of juist weg te laten. U kunt de tijd die u per vraag wilt besteden aanpassen. "
  },
  logo: {
    location : 'https://start.selectiehulp.nl/logo/',
    default : './img/nologo.png'
    },
  banner: {
    location : 'https://start.selectiehulp.nl/',
    default : './img/nologo.png'
    },
  avatar : {
    location : 'https://start.selectiehulp.nl/',
    default : './img/noavatar.png' //'./img/avatar.png'
  },
  getIMageLink: function(type, src, allowDefault) {
      if (!src && !allowDefault) return src
      if (!src || src.indexOf('.') == -1) {
        src = this[type].default
      } else if (src.indexOf(':') === -1) {
        src = this[type].location + src.replace('/upload/','')//.replace('/','__')  
      }
     return src
  },
  nkc: {
    deeplink : 'https://start.selectiehulp.nl/app/?view=item&action=select&index='
  },
  rollbar: {
    accessToken: '96be48a54eeb4f02bf6e4d7bc4700af7',
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    source_map_enabled: true,
    environment: 'development',
    payload: {
      client: {
        javascript: {
          code_version: '1.0'
        }
      }
    }
  },
  language: 'nl-NL',
  //templates: 'https://spreadsheets.google.com/feeds/list/1m_9HiVxiQAjyGjGVyE8lBxIv2yHmEuj52YHj9Q9q3x4/16/public/values?gid=1413446741&single=true&alt=json',
  templates: '/templateList.json',
  google: {
    // clientSecret: 'mLNl8ayEwFNSmTT91PpAs3vv',
    apiKey: 'AIzaSyA0Taz64ZM6l1lQCVMvXXllr8YbLXbqNuY',
    clientId: '719896053881-5g982lifa2k63p7kpht14nqi582lki77.apps.googleusercontent.com',
    // discoveryDocs: ['https://calendar.googleapis.com/$discovery/rest?version=v4'],
    scope: 'https://www.googleapis.com/auth/userinfo.profile'
    // see all available scopes here: https://developers.google.com/identity/protocols/googlescopes'
  },
  event: {
    name: 'De Dyck',
    address: {name: 'Woudsedijk-zuid 43, Woubrugge', street: 'Woudsedijk-zuid 43', city: 'Woubrugge', zipcode: '2481 NB'}
  }
}

